import {getMethod, postMethod} from '~/api'

async function get(id) {
    return await getMethod(`/api/companies/${id}/settings`)
}

async function post(id, request) {
    return await postMethod(`/api/companies/${id}/settings`, request)
}

export {get, post}
